<template>
	<div class="baojia_air" :style="isdetail?'':stylecss">
		<el-card class="box-card"  v-for="(item,index) in list" :key="index">
			<div slot="header" class="clearfix">
				<span style="margin-right:15px">{{baojia_air_lang.startport}}  </span>
				<el-select style="width:200px" v-model="item.startport" size="mini" :filterable="true" :clearable="true" v-if="!isdetail">
					<el-option v-for="port in portlist" :key="port.label" :value="port.label" :label="port.label"></el-option>
				</el-select>
				<span v-if="isdetail">{{item.startport}}</span>
				<i v-if="!isdetail" class="el-icon-delete" style="color:red;margin-left:10px;" title="移除板块" @click="delarea(index)"></i>
			</div>
			<table class="tablecss" cellspacing="0">
					<thead>
						<td class="td1">{{baojia_air_lang.endport}}</td>
						<td class="td6">{{baojia_air_lang.feelist}}</td>
						<td class="td7">{{baojia_air_lang.remark}}</td>
						<td class="td8"  v-if="!isdetail"></td>
					</thead>
					<tbody>
						<tr v-for="(chunk,i) in item.setlist" :key="i">
							<td class="td2">
								<el-select v-model="chunk.endport" size="mini" :filterable="true" :clearable="true"  v-if="!isdetail" >
									<el-option v-for="port in portlist" :key="port.label" :value="port.label" :label="port.label"></el-option>
								</el-select>
								<span v-else>{{chunk.endport}}</span>
							</td>
							<td class="td6" valign="top">
								<table class="weightprice" cellspacing="0">
									<thead>
										<td class="td4">{{baojia_air_lang.packagetype}}</td> 
										<td class="td3">{{baojia_air_lang.packagelocation}}</td> 
										<td class="td1">{{baojia_air_lang.m}}</td>
										<td class="td1">{{baojia_air_lang.n}}</td>
										<td class="td1">{{baojia_air_lang.kg45}}</td>
										<td class="td1">{{baojia_air_lang.kg100}}</td>
										<td class="td1">{{baojia_air_lang.kg250}}</td>
										<td class="td1">{{baojia_air_lang.kg300}}</td>
										<td class="td1">{{baojia_air_lang.kg500}}</td>
										<td class="td1">{{baojia_air_lang.kg1000}}</td>
										<td class="td1">{{baojia_air_lang.kg2000}}</td>
										<td class="td1">{{baojia_air_lang.kg2500}}</td>
										<td class="td1">{{baojia_air_lang.kg3000}}</td>
										<td class="td1">{{baojia_air_lang.kg5000}}</td>
										<td class="td1">{{baojia_air_lang.charged}}</td>
										<td class="td2"  v-if="!isdetail"></td>
									</thead>
									<tbody>
										<tr v-for="(it ,idx) in chunk.weightprice" :key="idx">
											<td class="td4">
												<el-input type="text" v-model="it.packagetype" size="mini"  v-if="!isdetail"></el-input>
												<span v-else>{{it.packagetype}}</span>
											</td>
											<td class="td3">
												<el-input type="text" v-model="it.packagelocation" size="mini" v-if="!isdetail"></el-input>
												<span v-else>{{it.packagelocation}}</span>
											</td>
											<td class="td1">
												<el-input type="text" size="mini" v-model="it.m" v-if="!isdetail"></el-input>
												<span v-else>{{it.m}}</span>
												</td>
											<td class="td1">
												<el-input type="text" size="mini"  v-model="it.n" v-if="!isdetail"></el-input>
												<span v-else>{{it.n}}</span></td>
											<td class="td1">
												<el-input type="text" size="mini"  v-model="it.kg45" v-if="!isdetail"></el-input>
												<span v-else>{{it.kg45}}</span></td>
											<td class="td1">
												<el-input type="text" size="mini"  v-model="it.kg100" v-if="!isdetail"></el-input>
												<span v-else>{{it.kg100}}</span></td>
												<td class="td1">
													<el-input type="text" size="mini"  v-model="it.kg250" v-if="!isdetail"></el-input>
												<span v-else>{{it.kg250}}</span>
													</td>
											<td class="td1">
												<el-input type="text" size="mini"  v-model="it.kg300" v-if="!isdetail"></el-input>
												<span v-else>{{it.kg300}}</span></td>
											<td class="td1">
												<el-input type="text" size="mini"  v-model="it.kg500" v-if="!isdetail"></el-input>
												<span v-else>{{it.kg500}}</span></td>
											<td class="td1">
												<el-input type="text" size="mini"  v-model="it.kg1000" v-if="!isdetail"></el-input>
												<span v-else>{{it.kg1000}}</span></td>
												<td class="td1">
												<el-input type="text" size="mini"  v-model="it.kg2000" v-if="!isdetail"></el-input>
												<span v-else>{{it.kg2000}}</span></td>
											<td class="td1">
												<el-input type="text" size="mini"  v-model="it.kg2500" v-if="!isdetail"></el-input>
												<span v-else>{{it.kg2500}}</span></td>
											<td class="td1">
												<el-input type="text" size="mini"  v-model="it.kg3000" v-if="!isdetail"></el-input>
												<span v-else>{{it.kg3000}}</span></td>
											<td class="td1">
												<el-input type="text" size="mini"  v-model="it.kg5000" v-if="!isdetail"></el-input>
												<span v-else>{{it.kg5000}}</span></td>
											<td class="td1">
												<el-input type="text" size="mini"  v-model="it.charged" v-if="!isdetail"></el-input>
												<span v-else>{{it.charged}}</span></td>
											<td class="td2" v-if="!isdetail"><i class="el-icon-delete" style="color:red" @click="delweightprice(chunk,idx)"></i></td>
										</tr>
									</tbody>
								</table>
								<div style="margin:5px" v-if="!isdetail">
									<el-button size="mini" type="primary" @click="addprice(chunk)">{{baojia_air_lang.addprice}}</el-button>
								</div>
							</td>
							<td class="td7" valign="top">
								<el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6 }" v-model="chunk.remark" v-if="!isdetail"></el-input>
								<span v-else>{{chunk.remark}}</span>
							</td>
							<td class="td8" v-if="!isdetail">
								<i class="el-icon-delete" style="color:red" @click="delset(item,i)"></i>
							</td>
						</tr>
					</tbody>
				</table>
			<div style="margin-top:5px;margin-left:5px" v-if="!isdetail">
				<el-button size="mini" type="primary" @click="addport(false,item)">{{baojia_air_lang.addport}}</el-button>
				<el-button size="mini" type="primary" @click="addport(true,item)">{{baojia_air_lang.copyport}}</el-button>
			</div>
		</el-card>
		<div style="text-align:center;margin-bottom:10px;margin-top:10px;" v-if="!isdetail">
			<el-button  type="warning" @click="addarea">{{baojia_air_lang.addarea}}</el-button>
			<!-- <el-button type="primary" style="margin-left:15px;" @click="addflight">{{baojia_air_lang.addflight}}</el-button> -->
		</div>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span style="margin-right:28px">{{baojia_air_lang.tips}}  </span>
			</div>
			<el-row>
				<el-col :span="24" v-if="!isdetail">
					<div id="editor" ref="editor" style="margin-top:-10px" class="diveditor"></div>
				</el-col>
				<el-col :span="24" v-else>
					<div v-html="info.remark"></div>
				</el-col>
			</el-row>
		</el-card>
	</div>
</template>
<script>
import E from 'wangeditor';
export default {
	components: {
		
	},
	props: {
		item:{
			type: Object,
			default:function(){
				return {
					
				};
			}
		},
		isdetail:{
			type:Boolean,
			default:false
		}
	},
	data() {
		return {
			list:[],
			stylecss:{height:`${window.innerHeight - 210}px`, 'overflow-y': 'auto' },
			baojia_air_lang:{},
			c_id:'',
			portlist:[],
			editor: {},
			info:'',
			defaultlist:[
				{startport:'',
				setlist:[
				{
					endport:'',
					remark:'',
					weightprice:[{packagetype:'',packagelocation:'',m:'',n:'',kg45:'',kg100:'',kg250:'',kg300:'',kg500:'',kg1000:'',kg2000:'',kg2500:'',kg3000:'',kg5000:'',charged:''}]
				}
			]}],
			endport:''
		}
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/cw/setbaojia.scss');
	},
	methods:{
		init(param){
			debugger
			if(param.c_id!=undefined)
				this.c_id=param.c_id;
			if(param.info!=undefined)
				this.info=param.info;	
			if(param.endport!=undefined)
				this.endport=param.endport;
			this.loadlanguage();
			if(!this.isdetail)
				this.loadportlist();
		},
		loadportlist(){
			var that=this;
			this.$apipost.get.dic({type:'港口'}).then(res=>{
				if(res.list!=undefined){
					that.portlist=res.list;
				}
			});
		},
		loadlanguage(){
			var that=this;
			this.$public.GetLanguageByMode('baojia_air',this).then(res=>{
				if(res.state=='1')
					that.baojia_air_lang=that.$lang.label.baojia_air;
				that.getInfo();
			});
		},
		addarea(){
			//debugger
			this.list.push(JSON.parse(JSON.stringify(this.defaultlist[0])));
		},
		addport(iscopy,item){
			if(iscopy){
				var newitem=JSON.parse(JSON.stringify(item.setlist[item.setlist.length-1]));
				newitem.remark='';
				newitem.endport='';
				//debugger
				newitem.weightprice.forEach(e=>{
					for(var i in e){
						if(i.toString()!='packagetype'&&i.toString()!='packagelocation')
							e[i]="";
					}
				});
				//debugger
				item.setlist.push(newitem);
			}else
				item.setlist.push(JSON.parse(JSON.stringify(this.defaultlist[0].setlist[0])));
		},
		delset(item,i){
			if(item.setlist.length>0&&i>0)
				item.setlist.splice(i,1);
		},
		delweightprice(chuck,idx){
			if(chuck.weightprice.length>0&&idx>0)
				chuck.weightprice.splice(idx,1);
		},
		addprice(chuck,idx){
			debugger
			var weightprice=JSON.parse(JSON.stringify(chuck.weightprice[chuck.weightprice.length-1]));
			for(var i in weightprice)
				weightprice[i]="";
				
			chuck.weightprice.push(weightprice);
		},
		delarea(index){
			if(this.list.length>0&&index>0)
				this.list.splice(index,1);
		},
		addflight(){
			var c_id='';
			if(this.info.c_id!=undefined)
				c_id=this.info.c_id;
			this.$public.ActionControl({l_pagetype:'flight',l_handetype:'opentab',
			urlparam:{c_id:c_id},l_name:this.baojia_air_lang.flighttitle,l_tabname:this.baojia_air_lang.flighttitle},this);
		},
		getInfo(){
			var that=this;
			if(this.c_id!=''){
				var paraminfo={
					c_id:this.info.c_id,
					type:this.info.type,
					endport:this.endport
				}
				this.$apipost.get.GetSchemeList({paraminfo:paraminfo}).then(res=>{
					if(res.state=='1')
						that.list=res.list;
					// else
					// 	this.$tool.message(that.baojia_air_lang.getinfofail, 0);
				});
			}
			else{
				this.list=JSON.parse(JSON.stringify(this.defaultlist));
			}
			if(!this.isdetail)
				this.initEditor();
		},
		
		//初始化富文本框内容
		initEditor() {
			var html='';
			if(this.info!='')
				html=this.info.remark;
			this.editor = new E(this.$refs.editor);
			this.editor.config.height =170;
			this.editor.config.excludeMenus = ['emoticon','image', 'video', 'undo', 'redo', 'todo'];
			this.editor.config.showLinkImg = false;
			this.editor.config.placeholder =this.baojia_air_lang.remarkplaceholder;
			this.editor.create();
			if(html!=undefined)
				this.editor.txt.html(html);
		},
		flightcallback(e){
			
		}
	},
}
</script>

<style>
</style>